import { useEffect } from "react";

import { TOKEN_KEY, logout } from "../slices/authSlice";
import { clearRefreshToken } from "../../../shared/lib/api/baseQueryWithReauth";
import { useAppDispatch } from "../../../app/store";
import { ROUTES } from "../../../shared/constants/app.constants";

// ── Cross-tab logout sync ─────────────────────────────────────────────────
// The `storage` event only fires in OTHER tabs/windows, never the one that
// made the change — so this mirrors a logout triggered in one tab into every
// other open tab, regardless of which route/layout each tab is on.
//
// Mounted once from App.tsx (not from Header) so it's active even on
// fullscreen routes that skip the Header/MainLayout chrome.
export const useAuthSync = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === TOKEN_KEY && event.newValue === null) {
        dispatch(logout());
        clearRefreshToken();
        window.location.href = ROUTES.LOGIN;
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [dispatch]);
};
